export const contact = {
  //全局
  service: {
    telephone: '15057338660',
  },
}
